import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Constants } from 'src/app/shared/model/Constants';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { DocumentInfoSearchResultItem } from '../../models/DocumentInfoSearchResultItem';
import { SearchDocumentInfoCriteria } from '../../models/SearchDocumentInfoCriteria';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { DocumentService } from '../../service/document.service';
import { ShowDocumentComponent } from '../show-document/show-document.component';
import { DocumentKind } from 'src/app/shared/model/DocumentKind';
import { Router } from '@angular/router';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { DocumentGenerationService } from '../../service/document-generation.service';
import { SendSignedDocumentRequest } from '../../models/SendSignedDocumentRequest';

@Component({
  selector: 'app-show-documents-multiple2',
  templateUrl: './show-documents-multiple2.component.html',
  styleUrls: ['./show-documents-multiple2.component.scss']
})
export class ShowDocumentsMultiple2Component implements OnInit {

  constructor(
    private documentService: DocumentService,
    private customDialogService: CustomDialogService,
    private uiNotification: UiNotificationService,
    private documentGenerationService: DocumentGenerationService,
    private router: Router) {

    }

  searchDocumentInfoCriteria: SearchDocumentInfoCriteria;
  error: string;
  isLoading:boolean;
 
  documentInfos$: Observable<DocumentInfoSearchResultItem[]>;

  editMode: boolean;
  @Input() public referenceId: string;
  @Input() public referenceType: number;
  @Input() public documentKindId: number;
  @Input() allowUpload: false;
  @Input() allowSign: false;
  @Input() allowSendByEmail: false;
  @Input() disableSign: false;
  @Input() uploadFilesSettings : UploadFilesSettings;
  @Input() showIfEmpty = true;

  @Output() newItemUploadedEvent = new EventEmitter<string>();


  @ViewChild("showDocumentsMultiple2Dialog", { read: ViewContainerRef })
  public containerRef: ViewContainerRef;
  
  ngOnInit(): void {
    this.initForm();
    this.loadDocuments();
  }

  initForm(): void {

    this.searchDocumentInfoCriteria = {
      referenceType: this.referenceType,
      documentKindId: this.documentKindId,
      referenceId: this.referenceId.toString(),
      pageNumber: 1,
      rowsPerPage: Constants.MaxInt
    }
  }

  loadDocuments(){
    this.isLoading = true;
    this.documentInfos$ = this.documentService.searchDocumentInfo(this.searchDocumentInfoCriteria).pipe(
      tap(() => { this.isLoading = false; }));
  }


    showContent(documentInfoSearchResultItem: DocumentInfoSearchResultItem, newWindow = false){
      
      if(documentInfoSearchResultItem.isArchived){
        return;
      }

      const dialogSettings: CustomDialogSettings = {
        content: ShowDocumentComponent,
        minHeight: '60vh',
        minWidth: '60vw',
        maxHeight: '98vh',
        maxWidth: '98vw',
        appendTo: this.containerRef,
        title: ' ',
        dialogInputs: {
          documentInfo : documentInfoSearchResultItem
        }
      };
  
      this.customDialogService.showDialog(dialogSettings);
    }

    remove(documentInfoId: string){
      this.documentService.removeDocument(documentInfoId ).subscribe( ()=> this.loadDocuments());
    }


    /* UPLOAD INTEGRATION */
    newUploadedItem(ev:string){
      this.loadDocuments();
      this.newItemUploadedEvent.emit(ev);
    }

    isSignable(docKind: number): boolean{
      return this.allowSign && DocumentKind.isSignableDoc(docKind);
    }

    canBeSentByEmail(docKind: number): boolean{
      return this.allowSendByEmail && DocumentKind.allowSendByEmail(docKind);
    }

    openToSign(documentInfoSearchResultItem : DocumentInfoSearchResultItem){
      if(this.router.url.includes('claimsCenter')){
        this.router.navigate(['claimsCenter/signDocument/' + documentInfoSearchResultItem.id]);
      }
     
      if(this.router.url.includes('mobileCenter')){
        this.router.navigate(['mobileCenter/signDocument/' + documentInfoSearchResultItem.id]);
      }

    }

    sendSignedDocumentByEmail(documentInfoSearchResultItem : DocumentInfoSearchResultItem){
      const task = this.uiNotification.showRunningOperation('operations.sendingOngoing');
      
      const sendData: SendSignedDocumentRequest = {
        documentInfoId: documentInfoSearchResultItem.id,
      };

      this.documentGenerationService.sendSignedDocument(sendData).subscribe(
        () => {
          this.uiNotification.showSuccess('validations.documentSent');
          this.documentService.getDocument(documentInfoSearchResultItem.id).subscribe( {
            next: (res) => {
              this.loadDocuments();
            }
          });
          task.hide()
        }
      );
    }


}



